import { Action } from 'redux';

import { ScheduleLinkedTask } from '~src/bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

export interface ScheduleLinkedTaskReduxAction extends Action {
    readonly targetFlows: IContentInfo[];
}

export function scheduleLinkedTaskAction(targetFlows: IContentInfo[] | ISpaceItemDetailInfo<'flow'>[]): ScheduleLinkedTaskReduxAction {
  return {
    type: ScheduleLinkedTask,
    targetFlows
  };
}
